import { BottomSheet, type BottomSheetProps } from "@base/ui/BottomSheet";

type ResponsiveSheetProps = Omit<BottomSheetProps, "desktopLayout" | "ariaLabel"> & {
  ariaLabel: string;
};

/**
 * 모바일은 BottomSheet(드래그·safe area), 768px 이상은 오른쪽 제한 폭 panel로 보인다.
 * 하나의 portal·DOM에서 CSS 배치만 바뀌므로 breakpoint를 넘어도 children이 재마운트되지 않는다
 * (입력 중인 댓글·선택 상태 유지). ESC·배경 클릭 닫기, 초점 이동·가두기·복귀를 제공한다.
 */
export function ResponsiveSheet(props: ResponsiveSheetProps) {
  return <BottomSheet {...props} desktopLayout="panel" />;
}
